<template>
  <div class="modifica-dati-struttura" v-if="!isFetching">
    <h3>{{ labels.modifica_dati_struttura }}</h3>

    <div class="corpo-modifica-dati-struttura">
      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group v-bind:label="labels.struttura">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="codice"
              v-model="struttura.codice"
              maxlength="45"
              readonly
            ></b-form-input>
            <p class="errore" id="errore-codice" v-if="isError(errori.codice)">
              {{ labels_errori[errori.codice] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="8" xl="8">
          <b-form-group v-bind:label="labels.descrizione_struttura">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="descrizione"
              v-model="struttura.descrizione"
              maxlength="45"
            ></b-form-input>
            <span
              class="errore"
              id="errore-descrizione"
              v-if="isError(errori.descrizione)"
              >{{ labels_errori[errori.descrizione] }}</span
            >
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="12" xl="12">
          <b-form-group class="b-form-group" v-bind:label="labels.indirizzo">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="indirizzo"
              v-model="struttura.indirizzo"
              maxlength="255"
              type="text"
            ></b-form-input>
            <span
              class="errore"
              id="errore-indirizzo"
              v-if="isError(errori.indirizzo)"
              >{{ labels_errori[errori.indirizzo] }}</span
            >
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="2" lg="1" xl="1">
          <b-form-group class="b-form-group" v-bind:label="labels.cap">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="cap"
              v-model="struttura.cap"
              maxlength="5"
              type="text"
            ></b-form-input>
            <span class="errore" id="errore-cap" v-if="isError(errori.cap)">{{
              labels_errori[errori.cap]
            }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="8" lg="10" xl="10">
          <b-form-group class="b-form-group" v-bind:label="labels.localita">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="localita"
              v-model="struttura.localita"
              maxlength="255"
              type="text"
            ></b-form-input>
            <span
              class="errore"
              id="errore-localita"
              v-if="isError(errori.localita)"
              >{{ labels_errori[errori.localita] }}</span
            >
          </b-form-group>
        </b-col>
        <b-col sm="12" md="2" lg="1" xl="1">
          <b-form-group class="b-form-group" v-bind:label="labels.provincia">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="provincia"
              v-model="struttura.provincia"
              maxlength="2"
              type="text"
            ></b-form-input>
            <span
              class="errore"
              id="errore-provincia"
              v-if="isError(errori.provincia)"
              >{{ labels_errori[errori.provincia] }}</span
            >
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="6" xl="6">
          <b-form-group class="b-form-group" v-bind:label="labels.email">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="email"
              v-model="struttura.email"
              maxlength="255"
              type="text"
            ></b-form-input>
            <p class="errore" id="errore-email" v-if="isError(errori.email)">
              {{ labels_errori[errori.email] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="3" xl="3">
          <b-form-group class="b-form-group" v-bind:label="labels.telefono">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="telefono"
              v-model="struttura.telefono"
              maxlength="255"
              type="text"
            ></b-form-input>
            <p
              class="errore"
              id="errore-telefono"
              v-if="isError(errori.telefono)"
            >
              {{ labels_errori[errori.telefono] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="3" xl="3">
          <b-form-group class="b-form-group" v-bind:label="labels.lingua">
            <b-form-select
              style="margin: 0; width: auto; width: 100%"
              v-model="struttura.lingua"
              :options="lingue"
              size="sm"
              :plain="$store.state.SelectPlain"
            ></b-form-select>
            <p class="errore" id="errore-lingua" v-if="isError(errori.lingua)">
              {{ labels_errori[errori.lingua] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group label="Origine">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="descrizione-struttura"
              v-model="struttura.codice"
              maxlength="255"
              disabled="disabled"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group v-bind:label="labels.anni_neonati">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="anni-neonati-struttura"
              v-model="anni_neonati_struttura"
              maxlength="45"
              type="number"
            ></b-form-input>
            <p
              class="errore"
              id="errore-anni-neonati-struttura"
              v-if="isError(errori.anni_neonati_struttura)"
            >
              {{ labels_errori[errori.anni_neonati_struttura] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group v-bind:label="labels.anni_bambini">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="anni-bambini-struttura"
              v-model="anni_bambini_struttura"
              maxlength="45"
              type="number"
            ></b-form-input>
            <p
              class="errore"
              id="errore-anni-bambini-struttura"
              v-if="isError(errori.anni_bambini_struttura)"
            >
              {{ labels_errori[errori.anni_bambini_struttura] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group label="Origine">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="descrizione-simplebooking"
              value="simpleBooking"
              maxlength="255"
              disabled="disabled"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group v-bind:label="labels.anni_neonati">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="anni-neonati-simplebooking"
              v-model="simplebooking.anni_neonati"
              maxlength="45"
              type="number"
            ></b-form-input>
            <p
              class="errore"
              id="errore-anni-neonati-simplebooking"
              v-if="isError(errori.anni_neonati_simplebooking)"
            >
              {{ labels_errori[errori.anni_neonati_simplebooking] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group v-bind:label="labels.anni_bambini">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="anni-bambini-simplebooking"
              v-model="simplebooking.anni_bambini"
              maxlength="45"
              type="number"
            ></b-form-input>
            <p
              class="errore"
              id="errore-anni-bambini-simpleboking"
              v-if="isError(errori.anni_bambini_struttura)"
            >
              {{ labels_errori[errori.anni_bambini_simplebooking] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <br />
      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="12" xl="12">
          <b-form-group class="b-form-group">
            <b-form-checkbox
              v-bind:disabled="privacy_precedente == 'S'"
              id="consenso-privacy"
              v-model="struttura.consenso_privacy"
              name="consenso-privacy"
              value="S"
              unchecked-value
            >
              <i>
                {{ labels.acconsento_al_trattamento }}
                <b-link @click="VaiAPrivacy">{{
                  labels.leggi_informativa
                }}</b-link>
              </i>
            </b-form-checkbox>
            <p
              class="errore"
              id="errore-consenso-privacy"
              v-if="isError(errori.consenso_privacy)"
            >
              {{ labels_errori[errori.consenso_privacy] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <br />

      <b-form-row class="b-form-row" style="text-align: center">
        <b-col sm="12" md="12" lg="12" xl="12">
          <b-button
            style="width: 100%"
            variant="success"
            @click="invia"
            :disabled="invio_in_corso"
            >{{ labels.invia }}</b-button
          >
          <div class="errore" id="errore-invia" v-if="isError(errori.invia)">
            <br />
            {{ labels_errori[errori.invia] }}
            <br />
          </div>
        </b-col>
      </b-form-row>
      <br />
    </div>

    <br />
    <b-form-row class="b-form-row">
      <b-col sm="12" md="12" lg="12" xl="12">
        <strong>{{ labels.file_logo }}</strong>
        <br />
        <p style="text-align: justify">{{ labels.descrizione_file_logo }}</p>
        <div id="frame-file-logo" style="width: 100%">
          <img
            id="picture-file-logo"
            style="border-style: solid; border-color: orange"
            :src="nome_file_logo1"
            fluid
            alt="File logo"
            v-if="struttura.nome_file_logo != ''"
          />
          <div
            id="picture-file-logo2"
            style="
              height: 100px;
              border-style: solid;
              border-color: orange;
              display: block;
            "
            v-if="struttura.nome_file_logo == ''"
          ></div>
        </div>
        <br />
      </b-col>
    </b-form-row>

    <b-form-row class="b-form-row">
      <b-col sm="8" md="8" lg="8" xl="8">
        <b-form-group class="b-form-group">
          <b-form-file
            accept="image/*"
            v-bind:label="labels.file_logo"
            v-model="file_logo"
            :state="Boolean(file_logo)"
            :browse-text="labels.testo_pulsante_browse"
            :placeholder="labels.scegli_un_file"
            :drop-placeholder="labels.trascina_un_file_qui"
          ></b-form-file>
        </b-form-group>
      </b-col>
      <b-col sm="4" md="4" lg="4" xl="4">
        <b-form-group class="b-form-group">
          <b-button
            variant="warning"
            style="width: 100%"
            @click="spedisci_logo"
            :disabled="invio_in_corso"
            >{{ labels.invia_logo }}</b-button
          >
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import store from "@/store/index";
import router from "@/router/index";
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "ModificaDatiStruttura",
  data() {
    return {
      labels: {},
      labels_errori: {},
      errori: {},
      struttura: {
        codice: "",
        descrizione: "",
        indirizzo: "",
        cap: "",
        localita: "",
        provincia: "",
        telefono: "",
        email: "",
        stato: "",
        nome_file_logo: "",
        lingua: "",
        consenso_privacy: "",
      },
      anni_neonati_struttura: 2.99,
      anni_bambini_struttura: 11.99,
      simplebooking: {
        anni_neonati: 2.99,
        anni_bambini: 11.99,
      },
      size: "sm",
      file_logo: null,
      nome_file_logo1: "",
      isFetching: true,
      invio_in_corso: false,
      privacy_precedente: "",
      lingue: [
        { value: "IT", text: "Italiano" },
        { value: "EN", text: "English" },
        { value: "DE", text: "Deutsch" },
        //{ value: "FR", text: "Français }
      ],
    };
  },
  mixins: [utility],
  computed: {},
  components: {},

  methods: {
    scambia_file_logo() {
      this.nome_file_logo1 =
        this.$store.state.ServerURL +
        "LOGHI/STRUTTURE/" +
        this.struttura.nome_file_logo +
        "?t=" +
        Date.now();
    },

    invia() {
      try {
        if (!fn_ControllaDati(this)) {
          return;
        }

        let me = this;

        let dati_strutture_origine = [
          {
            origine: this.struttura.codice,
            codice_struttura: this.struttura.codice,
            anni_neonati: this.anni_neonati_struttura,
            anni_bambini: this.anni_bambini_struttura,
          },
          {
            origine: "SIMPLEBOOKING",
            codice_struttura: this.struttura.codice,
            anni_neonati: this.simplebooking.anni_neonati,
            anni_bambini: this.simplebooking.anni_bambini,
          },
        ];

        let parametri = {
          utente_collegato: this.$store.state.Utente,
          password_utente_collegato: this.$store.state.Password,
          dati_struttura: this.struttura,
          dati_strutture_origine: dati_strutture_origine,
        };

        let parametri_json = encodeURIComponent(JSON.stringify(parametri));

        let ServerURL = this.$store.state.ServerURL;
        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/AggiornaDatiStruttura",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$root.$children[0].$refs.ApplicationAlert.show(
                me.labels.aggiornamento_effettuato
              );

              me.$store.commit(
                "SettaDescrizioneStruttura",
                me.struttura.descrizione
              );
            } else if (response.data.errore == -2) {
              me.registraErrore(
                response.dati.esito,
                "ModificaDatiStruttura-invia"
              );
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "ModificaDatiStruttura-invia");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "ModificaDatiStruttura-invia");
      }
    },

    VaiAPrivacy() {
      let routeData = this.$router.resolve({
        name: "InformativaRegistrazioneStruttura",
      });
      window.open(routeData.href, "_blank");
    },

    spedisci_logo() {
      if (this.file_logo == null) {
        return;
      }

      let me = this;
      let ServerURL = this.$store.state.ServerURL;
      let formData = new FormData();
      formData.append("file", this.file_logo);

      fn_CambiaCursore("wait", this);
      this.invio_in_corso = true;

      axios
        .post(
          ServerURL +
            "CheckIn/UploadFile?nome_file=" +
            this.file_logo.name +
            "&tipo=S" +
            "&codice=" +
            this.$store.state.Struttura,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(function (response) {
          fn_CambiaCursore("default", me);
          if (response.data.errore == 0) {
            me.struttura.nome_file_logo = response.data.oggetto.nome_file_logo;
            me.scambia_file_logo();

            me.$bvModal
              .msgBoxOk(me.labels.file_logo_inviato, {
                title: me.labels.conferma_invio,
              })
              .then(function () {
                fn_RidimensionaLogo();
              });
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.dati.esito,
              "ModificaDatiStruttura-spedisci_logo"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "ModificaDatiStruttura-spedisci_logo");
        });
    },
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },

  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);

      window.onresize = function () {
        fn_RidimensionaLogo();
      };
      let me = this;

      let parametri = {
        utente_collegato: this.$store.state.Utente,
        password_utente_collegato: this.$store.state.Password,
        struttura: this.$store.state.Struttura,
      };
      let parametri_json = JSON.stringify(parametri);

      let ServerURL = this.$store.state.ServerURL;

      fn_CambiaCursore("wait", this);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/LeggiStruttura",
        data: parametri_json,
      })
        .then(function (response) {
          fn_CambiaCursore("default", me);
          if (response.data.errore == 0) {
            me.struttura = response.data.oggetto.dati_struttura;
            me.privacy_precedente =
              response.data.oggetto.dati_struttura.consenso_privacy;

            response.data.oggetto.dati_strutture_origine.forEach((element) => {
              if (element.origine == me.struttura.codice) {
                me.anni_neonati_struttura = element.anni_neonati;
                me.anni_bambini_struttura = element.anni_bambini;
              }
              if (element.origine == "SIMPLEBOOKING") {
                me.simplebooking.anni_neonati = element.anni_neonati;
                me.simplebooking.anni_bambini = element.anni_bambini;
              }
            });

            me.scambia_file_logo();
            me.isFetching = false;

            me.$nextTick(function () {
              fn_RidimensionaLogo();
            });
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.dati.esito,
              "ModificaDatiStruttura-created"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "ModificaDatiStruttura-created");
        });
    } catch (error) {
      this.registraErrore(error, "ModificaDatiStruttura-created");
    }
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtenteAmministratore = store.state.UtenteAmministratore;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_admin && !UtenteAmministratore)
      ) {
        router.push(
          "/amministrazione/permessiinsufficienti",
          null,
          function () {}
        );
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      modifica_dati_struttura: "Modifica dati struttura",
      struttura: "Struttura",
      descrizione_struttura: "Descrizione",
      indirizzo: "Indirizzo",
      cap: "CAP",
      localita: "Località",
      provincia: "Provincia",
      telefono: "Telefono",
      email: "Email",
      lingua: "Lingua",
      anni_neonati: "Max anni neonati",
      anni_bambini: "Max anni bambini",
      invia: "Invia",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 600x100 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };
    let labels_inglese = {
      modifica_dati_struttura: "Modifica dati struttura",
      struttura: "Struttura",
      descrizione_struttura: "Descrizione",
      indirizzo: "Indirizzo",
      cap: "CAP",
      localita: "Località",
      provincia: "Provincia",
      telefono: "Telefono",
      email: "Email",
      lingua: "Language",
      anni_neonati: "Max anni neonati",
      anni_bambini: "Max anni bambini",
      invia: "Invia",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 600x100 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };
    let labels_tedesco = {
      modifica_dati_struttura: "Modifica dati struttura",
      struttura: "Struttura",
      descrizione_struttura: "Descrizione",
      indirizzo: "Indirizzo",
      cap: "CAP",
      localita: "Località",
      provincia: "Provincia",
      telefono: "Telefono",
      email: "Email",
      lingua: "Sprache",
      anni_neonati: "Max anni neonati",
      anni_bambini: "Max anni bambini",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
      invia: "Invia",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 600x100 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };
    let labels_francese = {
      modifica_dati_struttura: "Modifica dati struttura",
      struttura: "Struttura",
      descrizione_struttura: "Descrizione",
      indirizzo: "Indirizzo",
      cap: "CAP",
      localita: "Località",
      provincia: "Provincia",
      telefono: "Telefono",
      email: "Email",
      lingua: "Language",
      anni_neonati: "Max anni neonati",
      anni_bambini: "Max anni bambini",
      invia: "Invia",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 600x100 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };

    let labels_errori_italiano = {
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      struttura_non_trovata: "Struttura non trovata",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      struttura_non_trovata: "Struttura non trovata",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      struttura_non_trovata: "Struttura non trovata",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      struttura_non_trovata: "Struttura non trovata",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaDatiStruttura-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};
    if (vm.struttura.codice.trim() == "") {
      vm.errori.codice = "dato_obbligatorio";
      esito = false;
    }
    if (vm.struttura.descrizione.trim() == "") {
      vm.errori.descrizione = "dato_obbligatorio";
      esito = false;
    }
    if (vm.struttura.indirizzo.trim() == "") {
      vm.errori.indirizzo = "dato_obbligatorio";
      esito = false;
    }
    if (vm.struttura.cap.trim() == "") {
      vm.errori.cap = "dato_obbligatorio";
      esito = false;
    }
    if (vm.struttura.localita.trim() == "") {
      vm.errori.localita = "dato_obbligatorio";
      esito = false;
    }
    if (vm.struttura.provincia.trim() == "") {
      vm.errori.provincia = "dato_obbligatorio";
      esito = false;
    }
    if (vm.struttura.telefono.trim() == "") {
      vm.errori.telefono = "dato_obbligatorio";
      esito = false;
    }
    if (vm.struttura.email.trim() == "") {
      vm.errori.email = "dato_obbligatorio";
      esito = false;
    } else {
      let pattern = vm.$store.state.PatternEmail;

      if (!pattern.test(vm.struttura.email)) {
        vm.errori.email = "indirizzo_email_non_valido";
        esito = false;
      }
    }
    if (vm.struttura.lingua.trim() == "") {
      vm.errori.lingua = "dato_obbligatorio";
      esito = false;
    }

    if (vm.struttura.consenso_privacy != "S") {
      vm.errori.consenso_privacy = "privacy_obbligatoria";
      esito = false;
    }

    if (esito) {
      return true;
    } else {
      vm.errori.invia = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaDatiStruttura-fn_ControllaDati");
  }
}

function fn_RidimensionaLogo() {
  let elemento = document.getElementById("frame-file-logo");
  if (elemento == null) {
    return;
  }

  let larghezza = elemento.offsetWidth;
  if (larghezza > 600) {
    larghezza = 600;
  }

  elemento = document.getElementById("picture-file-logo");
  if (elemento == undefined) {
    elemento = document.getElementById("picture-file-logo2");
  }

  elemento.style.width = larghezza.toString() + "px";
  elemento.style.height =
    (
      elemento.clientWidth / 6 +
      (elemento.offsetHeight - elemento.clientHeight)
    ).toString() + "px";
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped>
.modifica-dati-struttura {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px;
  padding: 20px;
}
</style>
